import { memo } from 'react';

import { Megaphone } from '@air/next-icons';
import { AlertBanner } from '@air/primitive-alert-banner';

import { ALERT_BANNER_MAINTENANCE_MODE } from '~/constants/localStorageKeys';
import { MAINTENANCE_MODE_BANNER_MESSAGE } from '~/constants/testIDs';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

export const MaintenanceModeBanner = memo(() => {
  const { maintenanceModeJson } = useFeatureFlags();

  if (!maintenanceModeJson?.bannerMessage) {
    return null;
  }

  return (
    <AlertBanner
      data-testid={MAINTENANCE_MODE_BANNER_MESSAGE}
      dismissDays={1}
      id={ALERT_BANNER_MAINTENANCE_MODE}
      prefix={<Megaphone className="size-4" />}
    >
      {maintenanceModeJson.bannerMessage}
    </AlertBanner>
  );
});

MaintenanceModeBanner.displayName = 'MaintenanceModeBanner';
